import { createFileRoute, notFound } from "@tanstack/react-router";

import { CommercialSectorPage } from "@/components/commercial/commercial-sector-page";
import { getCommercialSector } from "@/content/commercial/sectors";
import { breadcrumbJsonLdScript, commercialBreadcrumbTrail } from "@/lib/breadcrumbs";
import { pageSeo, serviceJsonLdScript } from "@/lib/seo";
import { SITE } from "@/lib/site";

export const Route = createFileRoute("/commercial-sectors/$slug")({
  loader: ({ params }) => {
    if (!getCommercialSector(params.slug)) throw notFound();
    return null;
  },
  head: ({ params }) => {
    const sector = getCommercialSector(params?.slug ?? "");
    if (!sector) {
      const seo = pageSeo({
        path: `/commercial-sectors/${params?.slug ?? ""}`,
        title: "Sector Not Found | CRS Energy",
        description:
          "The page you're looking for doesn't exist or has been moved.",
      });
      return {
        ...seo,
        meta: [...seo.meta, { name: "robots", content: "noindex, nofollow" }],
      };
    }
    return {
      ...pageSeo({
        path: sector.path,
        title: sector.metaTitle,
        description: sector.metaDescription,
        ogType: "article",
      }),
      scripts: [
        serviceJsonLdScript({
          name: sector.name,
          description: sector.metaDescription,
          serviceType: `Commercial Services for ${sector.name}`,
          url: `${SITE.url}${sector.path}`,
        }),
        breadcrumbJsonLdScript(commercialBreadcrumbTrail(sector.name, sector.path)),
      ],
    };
  },
  component: SectorRoute,
});

function SectorRoute() {
  const { slug } = Route.useParams();
  const sector = getCommercialSector(slug);
  if (!sector) return null;
  return <CommercialSectorPage sector={sector} />;
}
